module.exports = __webpack_public_path__ + "sa.479bb907.svg";